import React, { Component } from "react"
import { graphql, navigate, Link } from "gatsby"
import "../scss/search.scss"
import "../scss/main.scss"
import parse from "html-react-parser"
import { Helmet } from "react-helmet"

class Homepage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchTerm: null,
      matching: [],
    }
  }

  render() {
    const data = this.props.data.allWordpressPost.edges
    console.log(data)
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
        </Helmet>
        <div className="searchArea">
          <h1>Posts</h1>
          <input list="blogPosts" placeholder="Search" />

          <ul>
            {data.map(function(post, i) {
              return (
                <li>
                  <Link to={post.node.slug}>{parse(post.node.title)}</Link>
                </li>
              )
            })}
          </ul>
        </div>
      </>
    )
  }
}

export default Homepage

export const pageQuery = graphql`
  query {
    allWordpressPost {
      edges {
        node {
          content
          title
          slug
        }
      }
    }
  }
`
